import { jsx as b, jsxs as g } from "react/jsx-runtime";
import v from "classnames";
import C, { useMemo as s } from "react";
import t from "./index.es587.js";
import { useResizeObserver as O } from "@placer-ui/hooks";
import { BodyText as u } from "./index.es487.js";
const w = "notification-indicator", z = ({
  count: o,
  color: a = "brand",
  limitAt: e = 99,
  testId: d = w,
  variant: I = "default",
  children: c,
  ...l
}) => {
  const m = C.isValidElement(c), { containerRef: f, contentRect: n } = O(), i = I === "dot", r = o > e || String(o).split("").length > 2, h = v(t.baseStyle, {
    [t.default]: !i,
    [t.dot]: i,
    [t.brand]: a === "brand",
    [t.gray]: a === "gray",
    [t.onTopOfComponent]: m,
    [t.oval]: r
  }), p = s(() => o > e ? `${e}+` : o, [o, e]), y = s(() => {
    const N = i ? -2 : r ? 11 : 7;
    return n.width > 20 ? { right: -n.width - N + 20 } : { right: -N };
  }, [n.width, i, r]), T = s(
    () => /* @__PURE__ */ b(
      "div",
      {
        className: h,
        "data-testid": d,
        ref: f,
        style: y,
        ...l,
        children: !i && /* @__PURE__ */ b(u, { variant: "semi-bold", size: "small", color: "white", children: p })
      }
    ),
    [f, p, i, y, l, h, d]
  );
  return m ? /* @__PURE__ */ g("div", { className: t.withChildrenContainer, children: [
    c,
    T
  ] }) : T;
};
export {
  w as NOTIFICATION_INDICATOR_DEFAULT_TESTID,
  z as NotificationIndicator
};
//# sourceMappingURL=index.es93.js.map
